import React, {useState, useEffect} from 'react';
import { Link, Navigate, } from 'react-router-dom';
import { Modal, CloseButton, Form, Row, Col, } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import Divider from 'components/common/Divider';
import ReCAPTCHA from 'react-google-recaptcha';

import HabilitationService from 'services/habilitationsService';
import { Axios } from 'helpers/axios';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { formConnexionClient, formCreerClient } from 'helpers/yupValidationSchema';
import IconAlert from 'components/common/IconAlert';

const Login = ({hasLabel = true, redirectToHomePage = true, setAuthOkState = null, linkText = null, creationCompteDirect = false}) => {
    // MODAL
    const [showModal, setShowModal] = useState(false);
    const [showLoginForm, setShowLoginForm] = useState(!creationCompteDirect);
    const handleShowModal = () => {
        setShowModal(true);
    }
    const handleCloseModal = () => {
        setShowModal(false);
        reset();
        resetCreer();
        setReCaptchaToken("");
        setIsLoading(false);
        setLoginStatus(false);
        setErreurDeConnexion(false);
        setShowMFA(false);
        setShowLoginForm(!creationCompteDirect);
    }

    //LOGIN
    const [reCaptchaToken, setReCaptchaToken] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const { handleSubmit, formState: { errors }, setValue, reset, watch } = useForm({
        resolver: yupResolver(formConnexionClient),
        mode: 'onBlur',
    });

    const [loginStatus, setLoginStatus] = useState(false);
    const [erreurDeConnexion, setErreurDeConnexion] = useState(false);
    const [showFMA, setShowMFA] = useState(false);

    const [seSouvenir, setSeSouvenir] = useState(window.__ENV__.LOGIN_REMEMBER_DEFAULT);

    // Handler
    const seConnecter = async (data) => {
        try {
            setIsLoading(true);
            
            const response = await Axios.post('/publicRoutes/login', {
                mailClient: data.mailClient,
                motDePasse: data.motDePasse,
                mfa: data.mfa,
                reCaptchaToken: reCaptchaToken,
            });

            if(!response.data.auth==true) {
                setLoginStatus(false);
                setAuthOkState ? setAuthOkState(false) : null;
                setErreurDeConnexion(true);
                setIsLoading(false);
            }else{
                response.data.seSouvenir = seSouvenir;
                HabilitationService.saveCompleteSet(response.data);

                setLoginStatus(true);
                setAuthOkState ? setAuthOkState(true) : null;
                location.reload();
            }
        } catch (e) {
            setErreurDeConnexion(true);
            setIsLoading(false);
            console.error(e);
        }
    };

    const checkMFAneeded = async () => {
        try {
            setIsLoading(true);
            if(watch('mailClient'))
            {
                const response = await Axios.post('/publicRoutes/mfaNeeded', {
                mailClient: watch('mailClient'),
                });
                setShowMFA(response.data.mfaNeeded);
            }
            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }
    
    useEffect(()=>{
        if(HabilitationService.token)
        {
            HabilitationService.disconnect();
        }
    },[])

    //CREATE
    const { handleSubmit: handleSubmitCreer, formState: { errors: errorsCreer }, setValue: setValueCreer, reset: resetCreer, watch: watchCreer } = useForm({
        resolver: yupResolver(formCreerClient),
        mode: 'onBlur',
    });
    const [createResponse, setCreateResponse] = useState(undefined);
    const [showResponseModal, setShowResponseModal] = useState(false);
    const handleShowResponseModal = () => {
        handleCloseModal();
        setShowResponseModal(true);
    }
    const handleCloseResponseModal = () => {
        setShowResponseModal(false);
        setCreateResponse(undefined);
        location.reload();
    }
    const creerCompte = async (data) => {
        try {
            setIsLoading(true);

            const response = await Axios.post('/publicRoutes/register', {
                ...data,
                reCaptchaToken: reCaptchaToken,
            });

            setCreateResponse(response.data.created);

            handleShowResponseModal();

            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }

    //RESET PWD
    const resetPWD = async () => {
        try {
            if(watch("mailClient"))
            {
                setIsLoading(true);
                const response = await Axios.post('/publicRoutes/forgotPassword', {
                    mailClient: watch("mailClient"),
                });

                setCreateResponse(response.data.created);

                handleShowResponseModal();
                setIsLoading(false);
            }
        } catch (error) {
            console.error(error)
        }
    }

    return (<>

        {linkText ?
            <Link onClick={handleShowModal}>{linkText}</Link>
        : <>
            <IconButton
                size='sm'
                icon="user"
                variant="outline-primary"
                onClick={handleShowModal}
                className="d-none d-sm-block"
            >Espace Client</IconButton>

            <IconButton
                size='sm'
                icon="user"
                variant="outline-primary"
                onClick={handleShowModal}
                className="d-block d-sm-none"
            />
        </>}

        <Modal show={showModal} onHide={handleCloseModal} className="mt-4">
            <Modal.Header className="bg-shape modal-shape-header px-4 position-relative">
                <div className="position-relative z-1" data-bs-theme="light">
                    <h4 className="mb-0 text-white" id="authentication-modal-label">
                        Espace Client
                    </h4>
                    <p className="fs-10 mb-0 text-white">
                        {showLoginForm ? "Merci de vous connecter" : "Création de compte"}
                    </p>
                </div>
                <CloseButton
                    variant="white"
                    className="position-absolute end-0 me-2 mt-2 top-0"
                    onClick={handleCloseModal}
                />
            </Modal.Header>
            <Modal.Body className="p-4">
                {showLoginForm ? <>
                    <Form onSubmit={handleSubmit(seConnecter)}>
                        <Form.Group className="mb-3">
                            {hasLabel && <Form.Label>Mail</Form.Label>}
                            <Form.Control
                                placeholder={!hasLabel ? 'prenom.nom@mastructure.fr' : ''}
                                value={watch('mailClient')}
                                name="mailClient"
                                onChange={(e) => setValue('mailClient', e.target.value)}
                                onBlur={checkMFAneeded}
                                type="email"
                                isInvalid={!!errors.mailClient}
                            />
                            <small className="text-danger">{errors.mailClient?.message}</small>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            {hasLabel && <Form.Label>Mot de passe</Form.Label>}
                            <Form.Control
                                placeholder={!hasLabel ? 'Mot de passe' : ''}
                                value={watch('motDePasse')}
                                name="motDePasse"
                                onChange={(e) => setValue('motDePasse', e.target.value)}
                                type="password"
                                isInvalid={!!errors.motDePasse}
                            />
                            <small className="text-danger">{errors.motDePasse?.message}</small>
                        </Form.Group>

                        {showFMA ? 
                            <Form.Group className="mb-3">
                                {hasLabel && <Form.Label>Code MFA</Form.Label>}
                                <Form.Control
                                    placeholder={!hasLabel ? 'Code MFA' : ''}
                                    value={watch('mfa')}
                                    name="mfa"
                                    onChange={(e) => setValue('mfa', e.target.value)}
                                    type="text"
                                    isInvalid={!!errors.mfa}
                                />
                                <small className="text-danger">{errors.mfa?.message}</small>
                            </Form.Group>
                        : null}

                        <Row className="justify-content-between align-items-center">
                            <Col xs="auto">
                                <Form.Check type="checkbox" id="rememberMe" className="mb-0">
                                    <Form.Check.Input
                                        type="checkbox"
                                        name="remember"
                                        checked={seSouvenir}
                                        onChange={(e)=>{setSeSouvenir(e.target.checked)}}
                                    />
                                    <Form.Check.Label className="mb-0 text-700">
                                        Rester connecté
                                    </Form.Check.Label>
                                </Form.Check>
                            </Col>

                            {window.__ENV__.APP_RECAPTCHA_ENABLED ? (<>
                                <br/><br/>
                                <ReCAPTCHA
                                    sitekey={window.__ENV__.APP_RECAPTCHA_SITEKEY}
                                    onChange={(token) => {setReCaptchaToken(token)}}
                                    onExpired={() => {setReCaptchaToken("")}}
                                />
                            </>) : null}
                        </Row>

                        <Form.Group>
                            <IconButton
                                type="submit"
                                color="primary"
                                className="mt-3 mb-3 w-100"
                                icon='lock-open'
                                disabled={!watch('mailClient') || !watch('motDePasse') || isLoading}
                            >
                                Se connecter
                            </IconButton>
                        </Form.Group>

                        {erreurDeConnexion && <>
                            <center>
                                Echec de la connexion<br/>
                                <IconButton
                                    icon='question'
                                    size='sm'
                                    variant='outline-primary'
                                    className='mb-3 mt-1'
                                    onClick={resetPWD}
                                    disabled={!watch('mailClient')}
                                >Mot de passe oublié</IconButton>
                            </center>
                        </>}

                        {loginStatus && redirectToHomePage && <Navigate replace to="/" />}
                    </Form>

                    <Divider>Nouveau client ?</Divider>
                </>: null}
                                

                {showLoginForm ?
                    <IconButton
                        className="mt-3 mb-3 w-100"
                        variant='outline-success'
                        icon='user-plus'
                        onClick={()=>{setShowLoginForm(false)}}
                    >Créer mon compte</IconButton>
                :
                    <>
                        <center className='mb-3'><small>Dans un premier temps, veuillez créer votre <u>accès individuel et nominatif</u>. Vous pourrez dans un second temps déclarer votre structure, ou vous rattacher à une structure déjà existante.</small></center>
                            <Form onSubmit={handleSubmitCreer(creerCompte)}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nom</Form.Label>
                                            <Form.Control
                                                placeholder={!hasLabel ? 'Nom de famille' : ''}
                                                value={watchCreer('nomClient')}
                                                name="nomClient"
                                                onChange={(e) => setValueCreer('nomClient', e.target.value)}
                                                type="text"
                                                isInvalid={!!errorsCreer.nomClient}
                                            />
                                            <small className="text-danger">{errorsCreer.nomClient?.message}</small>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prénom</Form.Label>
                                            <Form.Control
                                                placeholder={!hasLabel ? 'Prénom' : ''}
                                                value={watchCreer('prenomClient')}
                                                name="prenomClient"
                                                onChange={(e) => setValueCreer('prenomClient', e.target.value)}
                                                type="text"
                                                isInvalid={!!errorsCreer.prenomClient}
                                            />
                                            <small className="text-danger">{errorsCreer.prenomClient?.message}</small>
                                        </Form.Group>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Mon adresse mail <small>(identifiant de connexion)</small></Form.Label>
                                            <Form.Control
                                                placeholder={!hasLabel ? 'prenom.nom@mastructure.fr' : ''}
                                                value={watchCreer('mailClient')}
                                                name="mailClient"
                                                onChange={(e) => setValueCreer('mailClient', e.target.value)}
                                                type="email"
                                                isInvalid={!!errorsCreer.mailClient}
                                            />
                                            <small className="text-danger">{errorsCreer.mailClient?.message}</small>
                                        </Form.Group>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Mon téléphone</Form.Label>
                                            <Form.Control
                                                placeholder={!hasLabel ? '06 xx xx xx xx' : ''}
                                                value={watchCreer('telClient')}
                                                name="telClient"
                                                onChange={(e) => setValueCreer('telClient', e.target.value)}
                                                type="text"
                                                isInvalid={!!errorsCreer.telClient}
                                            />
                                            <small className="text-danger">{errorsCreer.telClient?.message}</small>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {window.__ENV__.APP_RECAPTCHA_ENABLED ? (<>
                                    <br/><br/>
                                    <ReCAPTCHA
                                        sitekey={window.__ENV__.APP_RECAPTCHA_SITEKEY}
                                        onChange={(token) => {setReCaptchaToken(token)}}
                                        onExpired={() => {setReCaptchaToken("")}}
                                    />
                                </>) : null}

                                <Form.Group>
                                    <IconButton
                                        type="submit"
                                        variant="outline-success"
                                        className="mt-3 mb-3 w-100"
                                        icon='plus'
                                        disabled={!watchCreer('nomClient') || !watchCreer('prenomClient') || !watchCreer('mailClient') || isLoading}
                                    >
                                        Créer mon compte
                                    </IconButton>
                                </Form.Group>
                            </Form>
                        </>
                }
            </Modal.Body>
        </Modal>

        <Modal show={showResponseModal} onHide={handleCloseResponseModal} className="mt-4">
            <Modal.Header className="bg-shape modal-shape-header px-4 position-relative">
                <div className="position-relative z-1" data-bs-theme="light">
                    <h4 className="mb-0 text-white" id="authentication-modal-label">
                        Espace Client
                    </h4>
                    <p className="fs-10 mb-0 text-white">
                        Création de compte
                    </p>
                </div>
                <CloseButton
                    variant="white"
                    className="position-absolute end-0 me-2 mt-2 top-0"
                    onClick={handleCloseResponseModal}
                />
            </Modal.Header>
            <Modal.Body className="p-4">
                {createResponse ?
                    <IconAlert variant={'success'}>Veuillez consulter vos emails pour finaliser l'opération.</IconAlert>
                :
                    <IconAlert variant={'warning'}>Echec de l'opération, veuillez <Link to={"/contact"}>nous contacter</Link>.</IconAlert>
                }
            </Modal.Body>
        </Modal>
    </>);
};

Login.propTypes = {};

export default Login;
